// SHOPIFY FORM POP UP SHADOW ROOT CSS

(function () {
  function skioFormsStyle_apply() {
    try {
      const el = document.querySelector('shopify-forms-embed');

      if (!el) return false;

      // Shadow root might not be ready immediately
      if (!el.shadowRoot) return false;

      // Prevent duplicate injection
      if (el.shadowRoot.querySelector('#custom-forms-style')) return true;

      const style = document.createElement('style');
      style.id = 'custom-forms-style';

      style.textContent = `

        #app-embed ._formContainer_1q1d2_30 { border-radius: 0px !important;}
        #app-embed ._formContainer_1q1d2_30 input._formInputField_nag3b_7 { border-radius: 0px !important; }
        #app-embed ._formContainer_1q1d2_30 button._formSubmitButton_jnbzb_106 { border-radius: 0px !important; }
        #app-embed ._formContainer_1q1d2_30 h2._textHeading_2aowh_35 { margin-bottom: 16px !important; }
        #app-embed ._formContainer_1q1d2_30 ._formCloseButton_1684x_4 > svg { width: 16px !important; height: 16px !important; }
        #app-embed ._formContainer_1q1d2_30 ._formContainerCloseButtonPosition_1q1d2_282 { top: 20px !important;; right: 20px !important; }
        #app-embed ._formContainer_1q1d2_30 ._formHeader_jnbzb_24 { margin-bottom: 10px !important; }
      `;

      el.shadowRoot.prepend(style);

      console.log('Shopify Forms style injected');
      return true;

    } catch (err) {
      console.error('Forms styling error:', err);
      return true; // stop retrying if error
    }
  }

  // ---- Retry until shadowRoot is ready ----
  function skioFormsStyle_waitForEmbed() {

    const interval = setInterval(() => {
      const done = skioFormsStyle_apply();

      if (done) {
        clearInterval(interval);
      }
    }, 300);

    // Safety timeout (stop after 10s)
    setTimeout(() => clearInterval(interval), 10000);
  }

  // ---- Start when DOM changes ----
  const observer = new MutationObserver(() => {
    const el = document.querySelector('shopify-forms-embed');
    if (el) {
      observer.disconnect();
      skioFormsStyle_waitForEmbed();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();

// 